import React from 'react';
import { formatTrainingDate } from '../../../rosterTools/statistics/rosterHistoryChartData';
import TrainingLineIcon from '../../../rosterTools/components/TrainingLineIcon';

function TrainingLine({ training }) {
  return (
    <div className="member-dashboard__training-line">
      <TrainingLineIcon training={training} certified />
      <div className="member-dashboard__training-line-body">
        <strong>{training.label}</strong>
        <div className="member-dashboard__training-meta">
          <span>First: {formatTrainingDate(training.first)}</span>
          <span>Last: {formatTrainingDate(training.last)}</span>
          <span>Count: {training.count ?? '—'}</span>
        </div>
      </div>
    </div>
  );
}

export default function DashboardTrainingsList({
  player,
  showBasics = true,
  showSpec = true,
}) {
  const basic = Array.isArray(player?.basicDetails) ? player.basicDetails : [];
  const spec = Array.isArray(player?.specializationDetails)
    ? player.specializationDetails
    : [];

  if (!showBasics && !showSpec) {
    return (
      <p className="member-dashboard__panel-placeholder">
        No category selected. Activate a filter above to view trainings.
      </p>
    );
  }

  const singleColumn = !showBasics || !showSpec;

  return (
    <div
      className={
        'member-dashboard__trainings' +
        (singleColumn ? ' member-dashboard__trainings--single-col' : '')
      }
    >
      {showBasics ? (
        <div className="member-dashboard__trainings-col">
          <h3 className="member-dashboard__trainings-heading">Basic Trainings</h3>
          {basic.length ? (
            basic.map((t, i) => (
              <TrainingLine key={`${t.code || 't'}-${i}`} training={t} />
            ))
          ) : (
            <p className="member-dashboard__panel-placeholder">No basic training.</p>
          )}
        </div>
      ) : null}

      {showSpec ? (
        <div className="member-dashboard__trainings-col">
          <h3 className="member-dashboard__trainings-heading">Specializations</h3>
          {spec.length ? (
            spec.map((t, i) => (
              <TrainingLine key={`${t.code || 't'}-${i}`} training={t} />
            ))
          ) : (
            <p className="member-dashboard__panel-placeholder">No specialization.</p>
          )}
        </div>
      ) : null}
    </div>
  );
}
